/* Collection quick buy. The card's add button opens a popup with the product's
   Section Heroes quantity tiers, and the chosen tier goes to the cart with the
   same "_sh-bundle" tag the product page sends, so the app's discount function
   prices it. Data comes from /products/<handle>?view=sh-quick-buy. */
(function () {
  if (window.shQuickBuy) return;
  window.shQuickBuy = true;

  var LOG = '[sh-quick-buy]';
  var VIEW = 'sh-quick-buy';

  var cache = {};
  var state = null;
  var opener = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function modal() {
    return document.querySelector('[data-sh-qb]');
  }

  function t(key) {
    var el = modal();
    return (el && el.getAttribute('data-t-' + key)) || '';
  }

  // same formatter as sh-quantity-tiers.js: de-DE, trailing ,00 dropped
  function money(cents) {
    return (cents / 100)
      .toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/,00$/, '') + '€';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function idOf(value) {
    if (!value) return 0;
    return parseInt(String(value).split('/').pop(), 10) || 0;
  }

  /* ---------- data ---------- */

  function textOf(scope, selector) {
    var node = scope.querySelector(selector);
    return node ? node.textContent.trim() : '';
  }

  /* The app renders one .sh-bundle-block per offer. data-offer-index is 1-based,
     and the cart tag's "o" is that index minus one (bundle.js reads it the same way).
     Only same-product offers fit a single-product popup. */
  function tiersOf(doc) {
    var bundle = doc.querySelector('sh-bundle');
    if (!bundle || bundle.hasAttribute('disabled')) return null;

    var config = {};
    try {
      config = JSON.parse(bundle.querySelector('script[data-bundle-config]').textContent);
    } catch (e) {
      return null;
    }
    if (!config.shortId) return null;

    var offers = config.offers || [];
    var tiers = [];

    bundle.querySelectorAll('.sh-bundle-block').forEach(function (block) {
      var index = parseInt(block.getAttribute('data-offer-index'), 10);
      if (!index) return;

      var offer = offers[index - 1] || {};
      if (offer.type && offer.type !== 'same-product') return;

      var qty = parseInt(block.getAttribute('data-quantity'), 10) || 1;
      var gift = block.querySelector('[data-gift-variant-id]');

      tiers.push({
        offer: index - 1,
        qty: qty,
        type: block.getAttribute('data-discount-type') || 'none',
        value: parseFloat(block.getAttribute('data-discount-value')) || 0,
        title: textOf(block, '.sh-bundle-block-content-item-product-content-info-title') || qty + ' ' + t('piece'),
        subtitle: textOf(block, '.sh-bundle-block-content-item-product-content-info-subtitle') || t('per'),
        gift: gift ? idOf(gift.getAttribute('data-gift-variant-id')) : 0,
        preselect: !!offer.preselect
      });
    });

    return tiers.length ? { shortId: config.shortId, tiers: tiers } : null;
  }

  /* tiers stays null for a product without a bundle — the click then adds one
     piece through the card's own form, as before the popup existed */
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('[data-sh-qb-product]');
    if (!node) throw new Error('no product data in view');

    var product = JSON.parse(node.textContent);
    var bundle = tiersOf(doc);
    product.shortId = bundle ? bundle.shortId : null;
    product.tiers = bundle ? bundle.tiers : null;
    return product;
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=' + VIEW, {
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('view ' + res.status);
          return res.text();
        })
        .then(parse)
        .catch(function (err) {
          delete cache[handle];
          throw err;
        });
    }
    return cache[handle];
  }

  /* ---------- pricing ---------- */

  /* Per-piece price of a tier, as the discount function charges it. Percentage:
     discount one unit and round down to a whole cent (sh-quantity-tiers.js explains
     why). fixed_amount: the app takes value × 100 cents off the tier total. */
  function perPiece(tier, unit) {
    if (tier.type === 'percentage' && tier.value > 0) {
      return Math.max(0, Math.floor((unit * (100 - tier.value)) / 100 + 1e-9));
    }
    if (tier.type === 'fixed_amount' && tier.value > 0) {
      return Math.max(0, Math.round((unit * tier.qty - tier.value * 100) / tier.qty));
    }
    return unit;
  }

  function discounted(tier) {
    return (tier.type === 'percentage' || tier.type === 'fixed_amount') && tier.value > 0;
  }

  function badgeOf(tier) {
    if (!discounted(tier)) return '';
    if (tier.type === 'percentage') return t('save') + ' -' + tier.value + ' %';
    return t('save') + ' ' + money(tier.value * 100);
  }

  /* ---------- render ---------- */

  function variantById(id) {
    return state.product.variants.filter(function (v) {
      return String(v.id) === String(id);
    })[0];
  }

  function matchVariant(picks) {
    return state.product.variants.filter(function (v) {
      return picks.every(function (value, i) {
        return v.options[i] === value;
      });
    })[0];
  }

  function renderProduct(body) {
    var p = state.product;
    var row = el('div', 'sh-qb__product');

    if (p.image) {
      var img = el('img', 'sh-qb__image');
      img.src = p.image;
      img.alt = p.imageAlt || '';
      img.width = 56;
      img.height = 56;
      row.appendChild(img);
    }

    var text = el('div', 'sh-qb__product-text');
    var title = el('a', 'sh-qb__title', p.title);
    title.href = p.url;
    text.appendChild(title);
    if (p.subtitle) text.appendChild(el('p', 'sh-qb__subtitle', p.subtitle));
    row.appendChild(text);

    body.appendChild(row);
  }

  // one select per option, like the PDP's theme picker; single values stay inert
  function renderVariants(body) {
    var p = state.product;
    if (p.single || p.variants.length < 2) return;

    var wrap = el('div', 'sh-qb__variants');
    var current = variantById(state.variant) || p.variants[0];

    p.options.forEach(function (name, i) {
      var values = [];
      p.variants.forEach(function (v) {
        if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
      });

      var line = el('div', 'sh-qb__variant');
      var id = 'sh-qb-option-' + i;
      var label = el('label', 'sh-qb__variant-label', (name || t('option')) + ':');
      label.setAttribute('for', id);

      var select = el('select', 'sh-qb__select');
      select.id = id;
      select.setAttribute('data-sh-qb-option', i);
      values.forEach(function (value) {
        var opt = el('option', null, value);
        opt.value = value;
        if (current.options[i] === value) opt.selected = true;
        select.appendChild(opt);
      });

      if (values.length < 2) {
        select.setAttribute('data-sh-single', '');
        select.tabIndex = -1;
        select.setAttribute('aria-disabled', 'true');
      }

      line.appendChild(label);
      line.appendChild(select);
      wrap.appendChild(line);
    });

    wrap.addEventListener('change', function () {
      var picks = Array.prototype.map.call(wrap.querySelectorAll('[data-sh-qb-option]'), function (s) {
        return s.value;
      });
      var match = matchVariant(picks);
      if (match) state.variant = match.id;
      paint();
    });

    body.appendChild(wrap);
  }

  function renderTiers(body) {
    var group = el('div', 'sh-qb__tiers');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-labelledby', 'sh-qb-heading');

    state.product.tiers.forEach(function (tier, i) {
      var label = el('label', 'sh-qb__tier' + (discounted(tier) ? ' sh-qb__tier--deal' : ''));

      // the badge keeps its row on every tile, so the cards line up
      label.appendChild(el('span', 'sh-qb__badge', badgeOf(tier) || t('save')));

      var card = el('span', 'sh-qb__card');
      var input = el('input', 'sh-qb__input');
      input.type = 'radio';
      input.name = 'sh-qb-tier';
      input.value = i;
      input.checked = i === state.tier;
      card.appendChild(input);
      card.appendChild(el('span', 'sh-qb__radio'));
      card.appendChild(el('span', 'sh-qb__qty', tier.title));
      card.appendChild(el('span', 'sh-qb__price'));
      card.appendChild(el('s', 'sh-qb__compare'));
      card.appendChild(el('span', 'sh-qb__per', tier.subtitle));
      label.appendChild(card);

      group.appendChild(label);
    });

    group.addEventListener('change', function (e) {
      if (!e.target.matches('.sh-qb__input')) return;
      state.tier = parseInt(e.target.value, 10) || 0;
      paint();
    });

    body.appendChild(group);
  }

  // figures only — called on every tier or variant change
  function paint() {
    var box = modal();
    var variant = variantById(state.variant) || state.product.variants[0];
    var unit = variant.price;

    box.querySelectorAll('.sh-qb__tier').forEach(function (label, i) {
      var tier = state.product.tiers[i];
      var per = perPiece(tier, unit);
      var compare = discounted(tier) ? Math.max(unit, variant.compare) : variant.compare;

      label.classList.toggle('is-selected', i === state.tier);
      label.querySelector('.sh-qb__price').textContent = money(per);

      var cmp = label.querySelector('.sh-qb__compare');
      cmp.textContent = compare > per ? money(compare) : '';
      cmp.hidden = !(compare > per);
    });

    var tier = state.product.tiers[state.tier];
    var total = perPiece(tier, unit) * tier.qty;
    var button = box.querySelector('[data-sh-qb-add]');
    var atcLabel = box.querySelector('[data-sh-qb-label]');

    button.disabled = !variant.available || state.busy;
    atcLabel.textContent = variant.available ? t('label') + ' – ' + money(total) : t('soldout');
  }

  function render(product) {
    var box = modal();
    var body = box.querySelector('[data-sh-qb-body]');

    var tier = 0;
    product.tiers.forEach(function (x, i) {
      if (x.preselect) tier = i;
    });

    state = { product: product, tier: tier, variant: product.selected, busy: false };

    body.textContent = '';
    renderProduct(body);
    renderVariants(body);
    renderTiers(body);
    paint();
  }

  /* ---------- cart ---------- */

  /* The bundle app and UpCart patch window.fetch. Borrow a clean one from an
     iframe, as sh-legacy-atc.js does, so the add happens exactly once. */
  var rawFetch;

  function cartFetch(url, opts) {
    if (rawFetch === undefined) {
      rawFetch = null;
      try {
        var frame = document.createElement('iframe');
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        frame.style.cssText = 'position:absolute;top:0;left:0;width:0;height:0;border:0;visibility:hidden';
        document.body.appendChild(frame);
        var borrowed = frame.contentWindow && frame.contentWindow.fetch;
        if (typeof borrowed === 'function') rawFetch = borrowed.bind(frame.contentWindow);
      } catch (e) {
        // fall through to the patched fetch
      }
    }
    return (rawFetch || window.fetch)(url, opts);
  }

  function call(name) {
    var fn = window[name];
    if (typeof fn !== 'function') return null;
    try {
      return Promise.resolve(fn());
    } catch (e) {
      console.error(LOG, name, e);
      return Promise.resolve();
    }
  }

  // same order as sh-legacy-atc.js: UpCart, then SlideCart, then the theme drawer
  function openDrawer() {
    if (typeof window.seppSyncHeaderCart === 'function') window.seppSyncHeaderCart();

    var refresh = call('upcartRefreshCart') || call('upcartUpdateCart');
    if (refresh || typeof window.upcartOpenCart === 'function') {
      (refresh || Promise.resolve()).then(function () {
        call('upcartOpenCart');
      });
      return;
    }

    var slidecart = call('SLIDECART_UPDATE');
    if (slidecart) {
      slidecart.then(function () {
        call('SLIDECART_OPEN');
      });
      return;
    }

    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      return;
    }

    window.location = root() + 'cart';
  }

  // one line of qty pieces: Shopify merges the app's qty × 1 lines into this anyway
  function itemsOf() {
    var p = state.product;
    var tier = p.tiers[state.tier];
    var line = { id: Number(state.variant), quantity: tier.qty };
    var items = [line];

    if (p.shortId && tier.offer >= 0) {
      line.properties = { '_sh-bundle': JSON.stringify({ id: p.shortId, o: tier.offer }) };

      if (tier.gift) {
        items.push({
          id: tier.gift,
          quantity: 1,
          properties: { '_sh-bundle': JSON.stringify({ id: p.shortId, o: tier.offer, g: 1 }) }
        });
      }
    }

    return items;
  }

  function showError(message) {
    var box = modal().querySelector('[data-sh-qb-error]');
    box.textContent = message || '';
    box.hidden = !message;
  }

  function add() {
    if (!state || state.busy) return;
    var button = modal().querySelector('[data-sh-qb-add]');

    state.busy = true;
    button.classList.add('is-loading');
    button.disabled = true;
    showError('');

    cartFetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: itemsOf() })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        state.busy = false;
        button.classList.remove('is-loading');
        if (data && data.status) {
          showError(data.description || data.message || t('error'));
          paint();
          return;
        }
        close();
        openDrawer();
      })
      .catch(function (err) {
        console.error(LOG, err);
        state.busy = false;
        button.classList.remove('is-loading');
        showError(t('error'));
        paint();
      });
  }

  /* ---------- dialog ---------- */

  // only ever called with a product that has tiers, so it renders straight away
  function open(product, trigger) {
    var dialog = modal();
    opener = trigger;
    showError('');
    render(product);

    lockScroll();
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function close() {
    var dialog = modal();
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function onClosed() {
    unlockScroll();
    // preventScroll: the button is where the page already stands
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* overflow:hidden alone sent the page back to the top. Pin the body at its
     current offset instead and put the page back exactly there on close. The
     theme's smooth scroll-behavior would animate that, so it is forced instant. */
  var lockedY = 0;

  function lockScroll() {
    var html = document.documentElement;
    if (html.classList.contains('sh-qb-lock')) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    html.style.setProperty('--sh-qb-scroll-y', -lockedY + 'px');
    html.style.setProperty('--sh-qb-scrollbar', window.innerWidth - html.clientWidth + 'px');
    html.classList.add('sh-qb-lock');
  }

  function unlockScroll() {
    var html = document.documentElement;
    if (!html.classList.contains('sh-qb-lock')) return;
    html.classList.remove('sh-qb-lock');
    html.style.removeProperty('--sh-qb-scroll-y');
    html.style.removeProperty('--sh-qb-scrollbar');
    window.scrollTo({ top: lockedY, left: 0, behavior: 'instant' });
  }

  /* The bundle is only known once the view is fetched. Usually the hover prefetch
     has it ready; otherwise the card button shows the theme's spinner meanwhile,
     and the popup never opens just to close again. */
  function pending(trigger, on) {
    trigger.classList.toggle('is-loading', on);
    if (on) trigger.setAttribute('aria-busy', 'true');
    else trigger.removeAttribute('aria-busy');
  }

  function decide(trigger) {
    var handle = trigger.getAttribute('data-sh-qb-trigger');
    if (trigger.getAttribute('aria-busy') === 'true') return;
    pending(trigger, true);

    load(handle)
      .then(function (product) {
        pending(trigger, false);
        if (product.tiers) open(product, trigger);
        else submitCard(trigger);
      })
      .catch(function (err) {
        // no popup data, so keep the old behaviour: send the card's own form
        console.error(LOG, err);
        pending(trigger, false);
        submitCard(trigger);
      });
  }

  function submitCard(trigger) {
    var form = trigger && trigger.form;
    if (!form) return;
    trigger.setAttribute('data-sh-qb-skip', '');
    trigger.click();
    trigger.removeAttribute('data-sh-qb-skip');
  }

  function triggerOf(target) {
    var button = target.closest && target.closest('[data-sh-qb-trigger]');
    if (!button || button.disabled || button.hasAttribute('data-sh-qb-skip')) return null;
    return modal() ? button : null;
  }

  function bindDialog() {
    // two sections can each render the popup (e.g. two featured collections);
    // keep the first, or ids and lookups would point at two dialogs
    Array.prototype.slice.call(document.querySelectorAll('[data-sh-qb]'), 1).forEach(function (extra) {
      if (!extra.open) extra.remove();
    });

    var dialog = modal();
    if (!dialog || dialog.dataset.shBound) return;
    dialog.dataset.shBound = '1';

    dialog.addEventListener('click', function (e) {
      // a click on the backdrop lands on the dialog itself, outside the sheet
      if (e.target === dialog || e.target.closest('[data-sh-qb-close]')) {
        close();
        return;
      }
      if (e.target.closest('[data-sh-qb-add]')) add();
    });

    dialog.addEventListener('close', onClosed);
  }

  // capture phase: the theme's product-form must not add the single piece too
  document.addEventListener(
    'click',
    function (e) {
      var trigger = triggerOf(e.target);
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      bindDialog();
      decide(trigger);
    },
    true
  );

  // warm the cache before the click lands
  function prefetch(e) {
    var trigger = triggerOf(e.target);
    if (trigger) load(trigger.getAttribute('data-sh-qb-trigger')).catch(function () {});
  }

  document.addEventListener('pointerenter', prefetch, true);
  document.addEventListener('touchstart', prefetch, { capture: true, passive: true });
  document.addEventListener('focusin', prefetch);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindDialog);
  else bindDialog();
})();
